module.exports = __webpack_public_path__ + "img/Om-norsk-Sprogreformation_Wergelands-kontor.2c2e88e9.jpg";